export interface Store<T> {
  get: () => T;
  set: (updater: (previous: T) => T) => void;
  subscribe: (listener: () => void) => () => void;
}

/**
 * ~20-line external store. Deliberately not Context: chat state changes on
 * every keystroke and every socket frame, and a Context provider would
 * re-render the entire subtree each time. Components subscribe to exactly the
 * slice they read via `useSyncExternalStore`.
 */
export function createStore<T>(initial: T): Store<T> {
  let state = initial;
  const listeners = new Set<() => void>();

  return {
    get: () => state,
    set: (updater) => {
      const next = updater(state);
      if (Object.is(next, state)) return;
      state = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
